// Same list as backend/destinations.py — kept in sync manually.
export const DESTINATIONS = [
  {
    country: "Mexico",
    image: "https://images.unsplash.com/photo-1512813195386-6cf811ad3542?w=1200&q=80",
    spots: [
      "5D/4N CABO SAN LUCAS",
      "6D/5N CANCUN",
      "6D/5N CANCUN RIVIERA MAYA",
      "6D/5N PUERTO VALLARTA",
    ],
  },
  {
    country: "United States",
    image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&q=80",
    spots: [
      "4D/3N ALBUQUERQUE","4D/3N ATLANTA, GA","4D/3N ATLANTIC CITY","4D/3N BOSTON, MA","4D/3N BRANSON, MO",
      "4D/3N CAPE COD, MA","4D/3N CHARLESTON","4D/3N CHICAGO, IL","4D/3N COLORADO SPRINGS","4D/3N DAYTONA BEACH",
      "4D/3N DENVER, CO","4D/3N ESTES PARK","4D/3N FORT LAUDERDALE","4D/3N GALVESTON, TX","4D/3N GATLINBURG",
      "4D/3N GRAND CANYON NATIONAL PARK","4D/3N GULF SHORES","6D/5N HAWAII","4D/3N HOT SPRINGS","4D/3N LAKE TAHOE, CA/NV",
      "4D/3N LAS VEGAS, NV","4D/3N LOS ANGELES, CA","4D/3N MIAMI, FL","4D/3N MYRTLE BEACH, SC","4D/3N NAPA VALLEY",
      "4D/3N NASHVILLE, TN","4D/3N NEW ORLEANS, LA","4D/3N NEW YORK CITY, NY","4D/3N OCEAN CITY","4D/3N ORLANDO, FL",
      "4D/3N PALM SPRINGS, CA","4D/3N PANAMA CITY","4D/3N PHOENIX, AZ","4D/3N SAN ANTONIO, TX","4D/3N SAN DIEGO",
      "4D/3N SAN FRANCISCO","5D/4N SAN JUAN","4D/3N SAVANNAH, GA","4D/3N SEDONA","4D/3N ST. PETERSBURG",
      "4D/3N VIRGINIA BEACH, VA",
    ],
  },
  { country: "Thailand", image: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=1200&q=80",
    spots: ["5D/4N BANGKOK","8D/7N KOH SAMUI","6D/5N PATTAYA","8D/7N PHUKET"] },
  { country: "Indonesia", image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80",
    spots: ["8D/7N BALI"] },
  { country: "Greece", image: "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=1200&q=80",
    spots: ["5D/4N ATHENS","6D/5N CRETE","6D/5N SANTORINI"] },
  { country: "Spain", image: "https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=1200&q=80",
    spots: ["5D/4N BARCELONA","5D/4N BENIDORM","5D/4N MADRID","5D/4N MAJORCA","5D/4N TENERIFE, ES"] },
  { country: "Turkey", image: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1200&q=80",
    spots: ["4D/3N ANTALYA","5D/4N BODRUM","5D/4N ISTANBUL"] },
  { country: "Philippines", image: "https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?w=1200&q=80",
    spots: ["6D/5N BOHOL","5D/4N BORACAY"] },
  { country: "Australia", image: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=1200&q=80",
    spots: ["4D/3N BRISBANE, QLD","4D/3N CAIRNS, QLD","4D/3N DARWIN, NT","4D/3N GOLD COAST, QLD","4D/3N MACKAY, QLD",
      "4D/3N MELBOURNE, VIC","4D/3N PERTH, WA","4D/3N ROCKHAMPTON, QLD","4D/3N SYDNEY, NSW","4D/3N TOWNSVILLE, QLD"] },
  { country: "Hungary", image: "https://images.unsplash.com/photo-1541849546-216549ae216d?w=1200&q=80",
    spots: ["5D/4N BUDAPEST"] },
  { country: "Argentina", image: "https://images.unsplash.com/photo-1589909202802-8f4aadce1849?w=1200&q=80",
    spots: ["5D/4N BUENOS AIRES"] },
  { country: "South Africa", image: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=1200&q=80",
    spots: ["5D/4N CAPE TOWN"] },
  { country: "Colombia", image: "https://images.unsplash.com/photo-1592360437020-a4231ba17d81?w=1200&q=80",
    spots: ["5D/4N CARTAGENA","5D/4N MEDELLÍN"] },
  { country: "New Zealand", image: "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=1200&q=80",
    spots: ["5D/4N AUCKLAND","5D/4N BAY OF PLENTY AND ROTORUA","5D/4N CHRISTCHURCH","5D/4N DUNEDIN","5D/4N MARLBOROUGH","5D/4N WELLINGTON"] },
  { country: "United Arab Emirates", image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80",
    spots: ["5D/4N DUBAI"] },
  { country: "India", image: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=1200&q=80",
    spots: ["5D/4N GOA"] },
  { country: "Israel", image: "https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1200&q=80",
    spots: ["5D/4N JERUSALEM"] },
  { country: "France", image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&q=80",
    spots: ["4D/3N CANNES","5D/4N PARIS"] },
  { country: "Dominican Republic", image: "https://images.unsplash.com/photo-1552074284-5e88ef1aef18?w=1200&q=80",
    spots: ["6D/5N PUERTO PLATA","5D/4N PUNTA CANA"] },
  { country: "Brazil", image: "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=1200&q=80",
    spots: ["5D/4N RIO DE JANEIRO"] },
  { country: "Italy", image: "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=1200&q=80",
    spots: ["5D/4N FLORENCE","4D/3N MILAN","5D/4N NAPLES","5D/4N ROME","5D/4N VENICE"] },
  { country: "Sweden", image: "https://images.unsplash.com/photo-1509356843151-3e7d96241e11?w=1200&q=80",
    spots: ["5D/4N STOCKHOLM"] },
  { country: "Canada", image: "https://images.unsplash.com/photo-1519832979-6fa011b87667?w=1200&q=80",
    spots: ["4D/3N CALGARY","4D/3N EDMONTON","4D/3N HALIFAX","4D/3N MONTREAL","4D/3N NIAGARA FALLS","4D/3N OTTAWA","4D/3N QUEBEC","4D/3N REVELSTOKE","4D/3N TORONTO","4D/3N VANCOUVER","4D/3N VICTORIA","4D/3N WINNIPEG"] },
  { country: "Austria", image: "https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=1200&q=80",
    spots: ["5D/4N VIENNA"] },
  { country: "Fiji", image: "https://images.unsplash.com/photo-1589197331516-4d84b72ebde3?w=1200&q=80",
    spots: ["5D/4N FIJI"] },
  { country: "Vanuatu", image: "https://images.unsplash.com/photo-1559606535-539d113a1fbb?w=1200&q=80",
    spots: ["5D/4N VANUATU"] },
  { country: "Germany", image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=1200&q=80",
    spots: ["4D/3N BERLIN","5D/4N MUNICH"] },
  { country: "Ireland", image: "https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?w=1200&q=80",
    spots: ["4D/3N DUBLIN"] },
  { country: "Japan", image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=1200&q=80",
    spots: ["6D/5N KYOTO"] },
  { country: "Macau", image: "https://images.unsplash.com/photo-1547593467-9e2a3d6dfc57?w=1200&q=80",
    spots: ["6D/5N MACAU"] },
  { country: "Malaysia", image: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=1200&q=80",
    spots: ["6D/5N KUALA LUMPUR"] },
  { country: "Netherlands", image: "https://images.unsplash.com/photo-1512470876302-972faa2aa9a4?w=1200&q=80",
    spots: ["4D/3N AMSTERDAM"] },
  { country: "Saudi Arabia", image: "https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=1200&q=80",
    spots: ["4D/3N MECCA"] },
  { country: "Singapore", image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=1200&q=80",
    spots: ["6D/5N SINGAPORE"] },
  { country: "Korea, Republic of", image: "https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=1200&q=80",
    spots: ["6D/5N SEOUL"] },
  { country: "United Kingdom", image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200&q=80",
    spots: ["4D/3N EDINBURGH","4D/3N GLASGOW","4D/3N LONDON"] },
  { country: "Tanzania", image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=1200&q=80",
    spots: ["5D/4N ZANZIBAR"] },
  { country: "China", image: "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=1200&q=80",
    spots: ["5D/4N BEIJING"] },
  { country: "Denmark", image: "https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=1200&q=80",
    spots: ["5D/4N COPENHAGEN"] },
  { country: "Croatia", image: "https://images.unsplash.com/photo-1555990793-da11153b2473?w=1200&q=80",
    spots: ["5D/4N DUBROVNIK"] },
  { country: "Portugal", image: "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=1200&q=80",
    spots: ["5D/4N LISBON"] },
  { country: "Maldives", image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=1200&q=80",
    spots: ["6D/5N MALDIVES"] },
  { country: "Iceland", image: "https://images.unsplash.com/photo-1504893524553-b855bce32c67?w=1200&q=80",
    spots: ["5D/4N REYKJAVIK"] },
  { country: "Belgium", image: "https://images.unsplash.com/photo-1491557345352-5929e343eb89?w=1200&q=80",
    spots: ["4D/3N BRUSSELS"] },
];

export const TOTAL_DESTINATIONS = DESTINATIONS.reduce((n, c) => n + c.spots.length, 0);
export const TOTAL_COUNTRIES = DESTINATIONS.length;
